import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // Don't scroll to top when navigating within chats (e.g., /chats to /chats/:id)
    const isWithinChats =
      prevPathname.current.startsWith("/chats") &&
      pathname.startsWith("/chats");

    if (!isWithinChats) {
      window.scrollTo(0, 0);
    }

    prevPathname.current = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
